import { ScanSearchMailsDTO } from 'src/app/shared/interfaces/scans/scan-search-mail-dto.interface';

export class ScanSearchMailsParams {
  //? idKey : Or ID or Partial ID CONTAINED in the courrierId
  //? Will be [Start with] if flag down there Set to true
  public idKey?: string;

  //? ids : OR list of complete Id(s) of courrier(s)
  public ids?: number[];

  //? startWith : if search idKey must be [Start with] instead of [Contains]
  //? Default value : false
  public startWith?: boolean;

  //? orderDescending : records sort by Id [Ascending] if False, [Descending] if True
  //? Default value : false
  public orderDescending?: boolean;
}
export class ScanSearchMails {
  id: number;
  typeEntrantSortant: string;
  objet: string;
  canViewMail: boolean;
  title: string;
  constructor(data?: ScanSearchMailsDTO) {
    Object.assign(this, data);
  }
}

export class ScanSearchMailsForBatchAttachment {
  id: number;
  typeEntrantSortant: string;
  objet: string;
  canViewMail: boolean;
  splitGuid: string;
  constructor(data?: ScanSearchMailsDTO) {
    Object.assign(this, data);
  }
}
